import { gql } from "@apollo/client";

export const SerialNumberLookup = gql`
    query SerialNumberLookup(
        $serialNumber: String!,
        $imageCrop:  ResizeCrop
        $imageWidth: Int
        $imageHeight: Int
    ) {
        serialNumberLookup (serialNumber: $serialNumber){
            confidence
            serialNumber
            dateOfManufacture
            manufacturer {
                id
                name
            }
            proposedProductNode {
                id
                urn
                name
                productCode
                childrenNodeCount
                level {
                    key
                    rank
                }
                manufacturer {
                    id
                    name
                }
                image {
                    id
                    thumbnailLink (crop: $imageCrop, w: $imageWidth, h: $imageHeight)
                }
            }
            registeredAssets {
                id
                urn
                serialNumber
                product {
                    id
                    urn
                    productCode
                    name
                    image {
                        id
                        thumbnailLink (crop: $imageCrop, w: $imageWidth, h: $imageHeight)
                    }
                }
                dateOfManufacture
                manufacturer {
                    id
                    urn
                    name
                }
            }
        }
    }
`;
